import { render, staticRenderFns } from "./ServiceDashboard.vue?vue&type=template&id=dda38dc6&scoped=true&"
import script from "./ServiceDashboard.vue?vue&type=script&lang=js&"
export * from "./ServiceDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDashboard.vue?vue&type=style&index=0&id=dda38dc6&scoped=true&lang=css&"
import style1 from "./ServiceDashboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda38dc6",
  null
  
)

export default component.exports